import { useEffect, useState } from "react";
import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";
import { Button } from "components/Button/Button";

import { useGetChequePrintTemplates } from "./api";
import { ChequePrintTemplate } from "./types";
import { ChequePrintTemplateEditor } from "./components/ChequePrintTemplateEditor";
import { ChequePrintTemplatesList } from "./components/ChequePrintTemplatesList";

import styles from "./styles.module.scss";

type Selection = number | "new" | null;

export function ChequePrintTemplates(): JSX.Element {
  const { data: templates = [], isLoading } = useGetChequePrintTemplates({
    page: 1,
    pageSize: 1000,
  });

  const [selected, setSelected] = useState<Selection>(null);

  useEffect(() => {
    if (isLoading) return;

    if (!templates.length) {
      setSelected((prev) => (prev === "new" ? prev : "new"));
      return;
    }

    setSelected((prev) => {
      if (prev === "new") return prev;
      if (prev === null) return templates[0].printtemplateid;
      const exists = templates.some((t) => t.printtemplateid === prev);
      return exists ? prev : templates[0].printtemplateid;
    });
  }, [isLoading, templates]);

  const activeTemplate: ChequePrintTemplate | null =
    selected !== null && selected !== "new"
      ? templates.find((t) => t.printtemplateid === selected) ?? null
      : null;

  const isNew = selected === "new";

  if (isLoading) {
    return (
      <div className="flex w-full p-6 justify-center items-center">
        Загрузка…
      </div>
    );
  }

  return (
    <div className="flex w-full">
      <BaseLayout
        className={classNames("ml-2 mt-3 mb-3", styles.leftColumn)}
        header={
          <BoldText className={styles.editorTitle}>Шаблоны чеков</BoldText>
        }
        footer={
          <div className="flex flex-row justify-start items-center">
            <Button icon="plus" onClick={() => setSelected("new")} />
          </div>
        }
      >
        <ChequePrintTemplatesList
          templates={templates}
          selected={selected}
          onSelect={setSelected}
        />
      </BaseLayout>
      <ChequePrintTemplateEditor
        key={
          isNew
            ? "new"
            : activeTemplate
              ? String(activeTemplate.printtemplateid)
              : "empty"
        }
        template={activeTemplate}
        isNew={isNew}
        onCreated={(created) => setSelected(created.printtemplateid)}
        onDeleted={() => {
          setSelected(null);
        }}
      />
    </div>
  );
}
